export class AuditLogCategoryModel {
  CategoryId: number;
  Category: string;
  SubCategoryId: number;
  SubCategory: string;
}

export class CategoryList {
  CategoryId: number;
  Category: string;
  SubCategory: SubcategoryList[];
}

export class SubcategoryList {
  CategoryId: number;
  SubCategoryId: number;
  SubCategory: string;
  SelectedSubCategory: boolean;
}

export class SearchCategory {
  CategoryId: number;
  SubCategoryId: number;
}

